import { IGetReferralDetailsResponse, IGetReferralRewardDetailsResponse } from '../types/referral.types';
import { apiClient } from './client';

/** Get referral details based on entity/merchant ID, to know about referral created by merchant */
export const getReferralDetails = async (entityId: string) => {
  const resp = await apiClient.get<IGetReferralDetailsResponse>(`/referral/program/${entityId}`);
  return resp.data;
}

/** Get referral details based on code, for claiming process */
export const getReferralRewardDetails = async (code: string) => {
  const resp = await apiClient.get<IGetReferralRewardDetailsResponse>(`/referral/details/${code}`);
  return resp.data;
};

export const claimReferralReward = async (code: string) => {
  const resp = await apiClient.post<{ success: boolean; status: number }>(
    `/referral/claim/${code}`,
    {},
  )
  return resp.data
}
